import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/ui/page-header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3, Flame, Sparkles } from "lucide-react";

export const Route = createFileRoute("/_authenticated/app/slotting/")({ component: SlottingHub });

const TILES = [
  { to: "/app/slotting/abc", icon: BarChart3, title: "ABC analysis", desc: "Pareto bands by pick velocity over a configurable window." },
  { to: "/app/slotting/heatmap", icon: Flame, title: "Velocity heatmap", desc: "Pick density per location to spot golden-zone candidates." },
  { to: "/app/admin/slotting", icon: Sparkles, title: "AI recommendations", desc: "Generate move/replenishment recommendations with Lovable AI." },
] as const;

function SlottingHub() {
  return (
    <>
      <PageHeader title="Slotting & Optimization" description="ABC analysis, velocity heatmaps, and AI-driven slotting recommendations." />
      <div className="px-4 sm:px-6 py-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to as never}>
            <Card className="hover:bg-accent/40 transition-colors h-full">
              <CardHeader className="flex flex-row items-center gap-3 pb-2">
                <t.icon className="h-5 w-5 text-primary" />
                <CardTitle className="text-base">{t.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">{t.desc}</CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </>
  );
}